import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

export class Library extends React.Component {
  static initClass() {
    this.propTypes = {
      libraryItems: PropTypes.array,
      recentItems: PropTypes.array,
      loading: PropTypes.bool,
      onClose: PropTypes.func,
      onPhotoSelected: PropTypes.func
    };
  }

  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
    this.onPhotoSelected = this.onPhotoSelected.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);

    this.state =
      {search: null};
  }

  onClose(event) {
    event.preventDefault();
    return (typeof this.props.onClose === 'function' ? this.props.onClose(event) : undefined);
  }

  onPhotoSelected(photo, event) {
    event.preventDefault();
    return (typeof this.props.onPhotoSelected === 'function' ? this.props.onPhotoSelected(photo, event) : undefined);
  }

  onSearchChange(event) {
    return this.setState({search: event.target.value});
  }

  _searchFilter(search_term) {
    return function(item) {
      if (String(item.caption).toLowerCase().indexOf(search_term) > -1) {
        return true;
      }

      return _.any(item.tags, tag => String(tag).toLowerCase().indexOf(search_term) > -1);
    };
  }

  render() {
    let library_header; let library_item_elements; let recent_header; let recent_item_elements;
    let item;
    let recent_items = this.props.recentItems;
    let library_items = this.props.libraryItems;

    if (this.state.search && (String(this.state.search).trim() !== '')) {
      const search_term = String(this.state.search).toLowerCase().trim();
      recent_items = _.filter(recent_items, this._searchFilter(search_term));
      library_items = _.filter(library_items, this._searchFilter(search_term));
    }

    const me = this;
    const cancel_button = <div className="action_button">
      <button className="btn btn-color" onClick={this.onClose}>Cancel</button>
    </div>;

    if (recent_items && (recent_items.length > 0)) {
      recent_header = <div className="admin_header sub-heading">
        <span>Recent Items</span>
        {cancel_button}
      </div>;
      recent_item_elements = ((() => {
        const result = [];
        for (item of Array.from(recent_items)) {                 result.push(<img key={item.key}
                                        onClick={me.onPhotoSelected.bind(me, item)}
                                        src={item.thumb_url}
                                        width={item.thumb_width}
                                        height={item.thumb_height}/>);
        }
        return result;
      })());
    }

    if (library_items && (library_items.length > 0)) {
      library_header = <div className="admin_header sub-heading">
        <span>Photo Library</span>
        {recent_items.length == 0 && cancel_button}
      </div>;
      library_item_elements = ((() => {
        const result1 = [];
        for (item of Array.from(library_items)) {                 result1.push(<img key={item.key}
                                         onClick={me.onPhotoSelected.bind(me, item)}
                                         src={item.thumb_url}
                                         width={item.thumb_width}
                                         height={item.thumb_height}/>);
        }
        return result1;
      })());
    }

    const status_message = this.props.error ?
      "There was an error loading the library"
    : this.props.loading ?
      "Loading..."
    :
      null;

    if (this.props.loading) {
      return <div className="no-photos">
        <div className="drop-target">
          <div className="drop-target-text">
            Loading...
          </div>
        </div>
      </div>;
    } else if (false && (this.props.recentItems.length === 0) && (this.props.libraryItems.length === 0)) {
      return <div className="no-photos">
        <div className="drop-target">
          <div className="drop-target-text">
            Your recent photos are empty. Drag one here to add it.
            {' '/* jsx collapses spaces */}
            <button className="btn btn-color" onClick={this.onClose}>Go Back</button>
          </div>
        </div>
      </div>;
    }
      return <div className="photo-library">
        <p>{status_message}</p>

        <div className="photo-library-list">
          {recent_header}
          <div className="photo-library-list-items">
            {recent_item_elements}
          </div>

          {library_header}
          <div className="photo-library-list-items">
            {library_item_elements}
          </div>
        </div>
      </div>;

  }
}
Library.initClass();
